import axios from 'axios';

function getAuthHeaders() {
    const token = localStorage.getItem('userToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
}

const baseUrl = () => import.meta.env.VITE_BASE_URL;

/**
 * Resolves the visitor's display currency on first load (geo-detected for guests,
 * preference/profile-based for authenticated users) plus the current rate table.
 */
export async function fetchCurrencyContext({ signal } = {}) {
    const response = await axios.get(`${baseUrl()}/api/currency-context`, {
        headers: getAuthHeaders(),
        withCredentials: true,
        signal,
    });
    return response.data;
}

export async function fetchExchangeRates({ signal } = {}) {
    const response = await axios.get(`${baseUrl()}/api/exchange-rates`, { signal });
    return response.data;
}

export async function fetchCurrencyPreferences({ signal } = {}) {
    const response = await axios.get(`${baseUrl()}/api/currency-preferences`, {
        headers: getAuthHeaders(),
        signal,
    });
    return response.data;
}

/**
 * @param {{ displayMode?: string, preferredCountry?: string|null }} payload
 *   displayMode: "local" | "original". preferredCountry: ISO alpha-2, "" clears it, null leaves unchanged.
 */
export async function updateCurrencyPreferences(payload, { signal } = {}) {
    const response = await axios.put(`${baseUrl()}/api/currency-preferences`, payload, {
        headers: getAuthHeaders(),
        signal,
    });
    return response.data;
}
